import React from 'react'
import Header from "./Header"

function TermsOfService( data ) {
  return (
    <div className="gameTypesMainHolder">
        <Header headerContext='privacyPolicy'
        user={ data.user }
        logout={ data.logout }
        toggleGetChips={ data.toggleGetChips }
        width = { data.width }
        showSiteMenu = { data.showSiteMenu }
        toggleSiteMenu = { data.toggleSiteMenu }/>
        <div className='textContentHolder'>
        <h1>Our Commitment to Responsible Gaming</h1>
        <dl className="list">
            <li>At PokerStream, we are committed to providing a safe and enjoyable gaming environment. We believe that gaming should always be a form of entertainment, and we take responsible gaming seriously. Our goal is to ensure that our players have the tools and resources they need to make informed decisions and maintain control over their gaming habits.</li>
        </dl>

        <dl className="list">
            <dt>What is Responsible Gaming?</dt>
            <li>Responsible gaming means playing for fun, within your limits, and without causing harm to yourself or others. It involves understanding the risks, setting boundaries, and seeking help if gaming starts to negatively impact your life.</li>
        </dl>

        <dl className="list">
            <dt>Tips for Responsible Gaming</dt>
            <dt>
                <li>Set a budget and stick to it.</li>
                <li>Never gamble with money you can't afford to lose.</li>
                <li>Take regular breaks to avoid prolonged gaming sessions.</li>
                <li>Understand that gambling is a form of entertainment, not a way to make money.</li>
                <li>Keep track of the time and money you spend on gaming.</li>
                <li>Avoid gambling when under the influence of alcohol or when feeling stressed or upset.</li>
            </dt>
        </dl>

        <dl className="list">
            <dt>Self-Assessment</dt>
            <li>If you're unsure whether your gaming habits are healthy, take a moment to reflect on your behavior. Ask yourself:</li>
            <li>Do I spend more time or money on gaming than I intended?</li>
            <li>Do I feel guilty or anxious about my gaming habits?</li>
            <li>Am I neglecting responsibilities or relationships because of gaming?</li>
            <li>Have I tried to cut back on gaming but found it difficult?</li>
            <li>If you answered "yes" to any of these questions, consider seeking help or using the tools we provide to manage your gaming habits.</li>
        </dl>

        <dl className="list">
        <dt>Seeking Help</dt>
        <li>If you or someone you know is struggling with problem gambling, help is available. We encourage you to reach out to professional organizations that specialize in gambling addiction support:</li>

        <li><a className='link' href="https://www.gamblersanonymous.org" target="_blank" rel="noopener noreferrer">Gamblers Anonymous</a></li>
        <li><a className='link' href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer">BeGambleAware</a></li>
        <li><a className='link' href="https://www.ncpgambling.org" target="_blank" rel="noopener noreferrer">National Council on Problem Gambling</a></li>

        <li>Remember, seeking help is a sign of strength, not weakness. You are not alone, and support is always available.</li>
        </dl>

        <dl className="list">
            <dt>Preventing Underage Gaming</dt>
            <li>Gaming is strictly for individuals aged [insert legal age] and above. We take measures to verify the age of our players and encourage parents and guardians to use parental control tools to prevent underage access to gaming platforms.</li>
        </dl>
        </div>
    </div>
)}

export default TermsOfService